package one.healthium.insights.ui.insights

import co.touchlab.kermit.Logger
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.catch
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.onStart
import kotlinx.coroutines.flow.update
import one.healthium.base.preferences.AppPreferences
import one.healthium.domain.user.UserInteractor
import one.healthium.insights.domain.content.ContentOptions
import one.healthium.insights.domain.content.ContentRepository
import one.healthium.ui.common.message.UiMessage
import one.healthium.ui.common.message.UiMessageManager
import one.healthium.ui.common.vm.BaseViewModel

internal class InsightsViewModel(
    userInteractor: UserInteractor,
    contentRepository: ContentRepository,
    appPreferences: AppPreferences,
) : BaseViewModel() {
    private val _state = MutableStateFlow(InsightsUiState())
    val state = _state.asStateFlow()

    val messages = UiMessageManager()

    init {
        combine(
            userInteractor.observeUser().nullOnError(),
            appPreferences.isMetricFlow,
            contentRepository.getContent(ContentOptions.Category("general")).nullOnError(),
            contentRepository.getFavoriteContent().nullOnError(),
            contentRepository.getRecentlyContent().nullOnError(),
        ) { user, isMetric, contentScreenModel, favorites, recent ->
            _state.update { state ->
                state.copy(
                    loading = false,
                    user = user,
                    isMetrics = isMetric,
                    insightsScreen = contentScreenModel,
                    favorites = favorites,
                    recently = recent,
                )
            }
        }
            .onStart {
                _state.update { state -> state.copy(loading = true) }
            }
            .catch {
                Logger.e("Error observing content", it)
                _state.update { state -> state.copy(loading = false) }
                messages.add(UiMessage.throwable(it))
            }
            .launch()
    }
}

private fun <T> Flow<T>.nullOnError(): Flow<T?> = this.map { it as T? }.catch {
    emit(null)
    Logger.e("Error in flow", it)
}